import {useRouteMatch} from "react-router-dom";
import { PdfReadySignal } from "./components/pdfReadySignal";
import {useEffect, useState} from "react";
import {BeskaeftigelseModel} from "../../../pages/sendStpsAnsoegning/beskaeftigelse/beskaeftigelseModel";
import "./pdfStyling/laegeligBeskaeftigelsePdf.scss"
import {UddannelseTypeEnum} from "../../sharedmodels/stilling/uddannelseTypeEnum";
import {LaegeligBeskaeftigelseText} from "../../../pages/sendStpsAnsoegning/beskaeftigelse/beskaeftigelseText";
import PdfComponent from "core/components/pdf/components/pdfComponent";
import {Localizer} from "../../../infrastructure/localization/localizer";
import {PdfBeskaeftigelseHeaderComponent} from "./pdfHeaders/pdfBeskaeftigelseHeaderComponent";
import {useFetchWithErrorHandlingPdf} from "./hooks/useFetchWithErrorHandlingPdf";
import useLogbogApi from "../../hooks/useLogbogApi";
import useStamdataApi from "../../hooks/useStamdataApi";
import {PdfBeskaeftigelseHeaderModel} from "./models/pdfBeskaeftigelseHeaderModel";
import { fetchBeskaeftigelseHeader } from "./helpers/pdfFetchers";

export function LaegeligBeskaeftigelsePdf() {

    const routeMatch = useRouteMatch();
    const routeParams = (routeMatch.params as {
        ansoegningId: string,
        brugerId: string,
        brugerMaalbeskrivelseId: string,
        uddannelseTypeEnum: UddannelseTypeEnum
    });
    const [beskaeftigelser, setBeskaeftigelser] = useState<BeskaeftigelseModel[]>();
    const [headerData, setHeaderData] = useState<PdfBeskaeftigelseHeaderModel>();
    const [dataLoaded, setDataLoaded] = useState(false);
    const setError = useFetchWithErrorHandlingPdf();
    const { beskaeftigelseApi, logbogUserInfoApi } = useLogbogApi();
    const { stamdataSpecialeApi, stamdataMaalbeskrivelseApi } = useStamdataApi();

    useEffect(() => {
        const fetchData = async () => {
            const [beskaeftigelserResponse, header] = await Promise.all([
                beskaeftigelseApi.getBeskaeftigelserByAnsoegningsId(routeParams.ansoegningId),
                fetchBeskaeftigelseHeader(routeParams.brugerId, routeParams.brugerMaalbeskrivelseId, { stamdataMaalbeskrivelseApi, stamdataSpecialeApi, logbogUserInfoApi }),
            ]);
            setBeskaeftigelser(beskaeftigelserResponse);
            setHeaderData(header);
            setDataLoaded(true);
        };
        fetchData().catch(setError);
    }, [routeParams.ansoegningId, routeParams.brugerId, routeParams.brugerMaalbeskrivelseId]);

    return (
        <PdfComponent>
            <h2 className={"margin-bottom-m"}>
                {Localizer.beskaeftigelsePdf_skemaTilOversigt()}
            </h2>
            {headerData &&
                <PdfBeskaeftigelseHeaderComponent
                    data={headerData}
                />
            }
            <div className={"flex-container-column margin-bottom-xl margin-top-l"}>
                <p>{Localizer.beskaeftigelsePdf_skemaOgMedsend()}</p>
                <p className={"beskaeftigelse-pdf-text-underline"}>{Localizer.beskaeftigelsePdf_skemaUdfylesFoelgende() + ":"}</p>
                {<LaegeligBeskaeftigelseText uddannelseTypeEnum={routeParams.uddannelseTypeEnum}/>}
            </div>
            <PdfComponent.NonBreakableItem className={"card shadow-none"}>
                <div
                    className={"card-header"}
                    style={{
                        display: "grid",
                        gridTemplateColumns: "2fr 2fr 2fr 2fr 2fr 1fr 1fr",
                        gap: "5px",
                    }}
                >
                    <div className={"beskaeftigelse-pdf-list-header flex-wrap text-break"}>{Localizer.beskaeftigelse_stillingsbetegnelse()}</div>
                    <div className={"beskaeftigelse-pdf-list-header flex-wrap text-break"}>{Localizer.beskaeftigelse_ansaettelsessted()}</div>
                    <div className={"beskaeftigelse-pdf-list-header flex-wrap text-break"}>{Localizer.afdeling()}</div>
                    <div className={"beskaeftigelse-pdf-list-header flex-wrap text-break"}>{Localizer.startdato()}</div>
                    <div className={"beskaeftigelse-pdf-list-header flex-wrap text-break"}>{Localizer.slutdato()}</div>
                    <div className={"beskaeftigelse-pdf-list-header flex-wrap text-break"}>{Localizer.beskaeftigelse_maaneder()}</div>
                    <div className={"beskaeftigelse-pdf-list-header flex-wrap text-break"}>{Localizer.beskaeftigelse_Timer()}</div>
                </div>
                {beskaeftigelser &&
                    beskaeftigelser.map((beskaeftigelse, index) => (
                        <PdfComponent.NonBreakableItem key={index}>
                            <div
                                className={"card-body"}
                                style={{
                                    display: "grid",
                                    gridTemplateColumns: "2fr 2fr 2fr 2fr 2fr 1fr 1fr",
                                    gap: "5px",
                                    alignItems: "center",
                                }}
                            >
                                <div className={"beskaeftigelse-pdf-list-item flex-wrap text-break"}>
                                    <p>{beskaeftigelse.stillingsbetegnelse}</p>
                                    <p>{beskaeftigelse.stillingsnummer}</p>
                                </div>
                                <div className={"beskaeftigelse-pdf-list-item flex-wrap text-break"}>{beskaeftigelse.ansaettelsessted}</div>
                                <div className={"beskaeftigelse-pdf-list-item flex-wrap text-break"}>{beskaeftigelse.afdeling}</div>
                                <div className={"beskaeftigelse-pdf-list-item flex-wrap text-break"}>{beskaeftigelse.startdato?.dateWithoutTimeFormat(false)}</div>
                                <div className={"beskaeftigelse-pdf-list-item flex-wrap text-break"}>{beskaeftigelse.slutdato?.dateWithoutTimeFormat(false)}</div>
                                <div className={"beskaeftigelse-pdf-list-item flex-wrap text-break"}>{beskaeftigelse.maaneder}</div>
                                <div className={"beskaeftigelse-pdf-list-item flex-wrap text-break"}>{beskaeftigelse.nedsatTidAntalTimer}</div>
                            </div>
                        </PdfComponent.NonBreakableItem>
                    ))}
            </PdfComponent.NonBreakableItem>
            <PdfReadySignal when={dataLoaded} />
        </PdfComponent>
    );
}
